import { AssignUserField, AuthUserPermission, Can, useUser } from '@cibo/profile'
import { AddressField } from '@cibo/ui'
import { Box, FormControl, FormGroup, FormLabel } from '@mui/material'
import { Field, useFormikContext } from 'formik'
import { TextField } from 'formik-mui'
import { useTranslation } from 'react-i18next'

export const FarmFormControls = ({ disableOwnerSelection }: { disableOwnerSelection: boolean }) => {
  const { t } = useTranslation('@cibo/landmanager/LandManager/FarmForm')
  const { initialValues } = useFormikContext<{
    sourceData?: { origin?: string; source?: string }
  }>()
  const user = useUser()
  const isEditingSelf = user.data?.isGrower()

  // TODO: adjust to use allowedActions when CPD-4767 is done
  const disable = initialValues?.sourceData?.origin === 'FieldAlytics'

  return (
    <Box sx={{ minWidth: 400 }}>
      <FormGroup>
        <FormControl>
          <FormLabel htmlFor="name" required>
            {t('name')}
          </FormLabel>
          <Field id="name" name="name" component={TextField} disabled={disable} />
        </FormControl>

        {!isEditingSelf && (
          <Can useAny={[AuthUserPermission.FARMS_MANAGE]}>
            <AssignUserField disabled={disableOwnerSelection || disable} name="owner" required />
          </Can>
        )}
      </FormGroup>

      <AddressField />
    </Box>
  )
}
